/**
 * @generated SignedSource<<56de70402784140f9ea757a11796c3e1>>
 * @relayHash 1a6ee940b59f13263fb0433f4d4a4419
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 272634a6bad5f4495beb14443ac52d9b9a4e0be5253252159abbdb36fd238b15

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraIssueSearchFieldSetSelectedState = "ALL" | "NON_SELECTED" | "SELECTED" | "%future added value";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "TIMELINE_PROJECT" | "%future added value";
export type JiraIssueSearchFieldSetsFilter = {
  fieldSetSelectedState?: JiraIssueSearchFieldSetSelectedState | null | undefined;
  searchString?: string | null | undefined;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null | undefined;
  projectKey?: string | null | undefined;
};
export type JiraViewQueryInput = {
  boardIdAndItemQuery?: JiraViewBoardIdAndItemQuery | null | undefined;
  projectKeyAndItemQuery?: JiraViewProjectKeyAndItemQuery | null | undefined;
  viewId?: string | null | undefined;
};
export type JiraViewBoardIdAndItemQuery = {
  boardId: AGG$Long;
  cloudId: string;
  itemId: string;
};
export type JiraViewProjectKeyAndItemQuery = {
  cloudId: string;
  itemId: string;
  projectKey: string;
};
export type fetchColumnPickerOptionsQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  filter?: JiraIssueSearchFieldSetsFilter | null | undefined;
  first?: number | null | undefined;
  jiraViewQueryInput?: JiraViewQueryInput | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  scope?: JiraIssueSearchScope | null | undefined;
  shouldUseNewQuery: boolean;
  viewId?: string | null | undefined;
};
export type fetchColumnPickerOptionsQuery$data = {
  readonly jira: {
    readonly issueSearchViewByNamespaceAndViewId?: {
      readonly fieldSets: {
        readonly edges: ReadonlyArray<{
          readonly cursor: string;
          readonly node: {
            readonly displayName: string;
            readonly fieldSetId: string;
            readonly fieldType: {
              readonly displayName: string | null | undefined;
            } | null | undefined;
            readonly type: string;
          };
        } | null | undefined>;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
        };
        readonly totalCount: number;
      };
    };
    readonly jiraIssueSearchView?: {
      readonly fieldSets?: {
        readonly edges: ReadonlyArray<{
          readonly cursor: string;
          readonly node: {
            readonly displayName: string;
            readonly fieldSetId: string;
            readonly fieldSetPreferences: {
              readonly width: number | null | undefined;
            } | null | undefined;
            readonly fieldType: {
              readonly displayName: string | null | undefined;
            } | null | undefined;
            readonly type: string;
          };
        } | null | undefined>;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
        };
        readonly totalCount: number;
      } | null | undefined;
    };
  };
};
export type fetchColumnPickerOptionsQuery = {
  response: fetchColumnPickerOptionsQuery$data;
  variables: fetchColumnPickerOptionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraViewQueryInput"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jql"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "namespace"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldUseNewQuery"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v10 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v11 = {
  "kind": "Variable",
  "name": "namespace",
  "variableName": "namespace"
},
v12 = {
  "kind": "Variable",
  "name": "viewId",
  "variableName": "viewId"
},
v13 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/)
],
v14 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v15 = {
  "kind": "Variable",
  "name": "filter",
  "variableName": "filter"
},
v16 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v17 = [
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/)
],
v18 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v19 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v20 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v21 = {
  "kind": "ScalarField",
  "name": "fieldSetId"
},
v22 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v23 = {
  "kind": "ScalarField",
  "name": "type"
},
v24 = {
  "concreteType": "JiraFieldType",
  "kind": "LinkedField",
  "name": "fieldType",
  "plural": false,
  "selections": [
    (v22/*: any*/)
  ]
},
v25 = [
  (v10/*: any*/),
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "jql",
        "variableName": "jql"
      }
    ],
    "kind": "ObjectValue",
    "name": "issueSearchInput"
  },
  {
    "kind": "Variable",
    "name": "jiraViewQueryInput",
    "variableName": "jiraViewQueryInput"
  },
  (v11/*: any*/),
  (v12/*: any*/)
],
v26 = [
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  {
    "kind": "Variable",
    "name": "scope",
    "variableName": "scope"
  }
],
v27 = {
  "concreteType": "JiraFieldSetPreferences",
  "kind": "LinkedField",
  "name": "fieldSetPreferences",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "width"
    }
  ]
},
v28 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "name": "fetchColumnPickerOptionsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "condition": "shouldUseNewQuery",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "args": (v13/*: any*/),
                    "concreteType": "JiraIssueSearchView",
                    "kind": "LinkedField",
                    "name": "issueSearchViewByNamespaceAndViewId",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "args": (v17/*: any*/),
                          "concreteType": "JiraIssueSearchFieldSetConnection",
                          "kind": "LinkedField",
                          "name": "fieldSets",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": (v18/*: any*/),
                              "action": "THROW",
                              "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.totalCount"
                            },
                            (v19/*: any*/),
                            {
                              "kind": "RequiredField",
                              "field": {
                                "concreteType": "JiraIssueSearchFieldSetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  (v20/*: any*/),
                                  {
                                    "kind": "RequiredField",
                                    "field": {
                                      "concreteType": "JiraIssueSearchFieldSet",
                                      "kind": "LinkedField",
                                      "name": "node",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "kind": "RequiredField",
                                          "field": (v21/*: any*/),
                                          "action": "THROW",
                                          "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.fieldSetId"
                                        },
                                        {
                                          "kind": "RequiredField",
                                          "field": (v22/*: any*/),
                                          "action": "THROW",
                                          "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.displayName"
                                        },
                                        {
                                          "kind": "RequiredField",
                                          "field": (v23/*: any*/),
                                          "action": "THROW",
                                          "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.type"
                                        },
                                        (v24/*: any*/)
                                      ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node"
                                  }
                                ]
                              },
                              "action": "THROW",
                              "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges"
                            }
                          ]
                        },
                        "action": "THROW",
                        "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets"
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "jira.issueSearchViewByNamespaceAndViewId"
                }
              ]
            },
            {
              "condition": "shouldUseNewQuery",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "args": (v25/*: any*/),
                    "kind": "LinkedField",
                    "name": "jiraIssueSearchView",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "args": (v26/*: any*/),
                            "concreteType": "JiraIssueSearchFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSets",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": (v18/*: any*/),
                                "action": "THROW",
                                "path": "jira.jiraIssueSearchView.fieldSets.totalCount"
                              },
                              (v19/*: any*/),
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "concreteType": "JiraIssueSearchFieldSetEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    (v20/*: any*/),
                                    {
                                      "kind": "RequiredField",
                                      "field": {
                                        "concreteType": "JiraIssueSearchFieldSet",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "RequiredField",
                                            "field": (v21/*: any*/),
                                            "action": "THROW",
                                            "path": "jira.jiraIssueSearchView.fieldSets.edges.node.fieldSetId"
                                          },
                                          {
                                            "kind": "RequiredField",
                                            "field": (v22/*: any*/),
                                            "action": "THROW",
                                            "path": "jira.jiraIssueSearchView.fieldSets.edges.node.displayName"
                                          },
                                          {
                                            "kind": "RequiredField",
                                            "field": (v23/*: any*/),
                                            "action": "THROW",
                                            "path": "jira.jiraIssueSearchView.fieldSets.edges.node.type"
                                          },
                                          (v24/*: any*/),
                                          (v27/*: any*/)
                                        ]
                                      },
                                      "action": "THROW",
                                      "path": "jira.jiraIssueSearchView.fieldSets.edges.node"
                                    }
                                  ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraIssueSearchView.fieldSets.edges"
                              }
                            ]
                          }
                        ],
                        "type": "JiraSpreadsheetView",
                        "abstractKey": "__isJiraSpreadsheetView"
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "jira.jiraIssueSearchView"
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v6/*: any*/),
      (v9/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v8/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "fetchColumnPickerOptionsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "shouldUseNewQuery",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": (v13/*: any*/),
                "concreteType": "JiraIssueSearchView",
                "kind": "LinkedField",
                "name": "issueSearchViewByNamespaceAndViewId",
                "plural": false,
                "selections": [
                  {
                    "args": (v17/*: any*/),
                    "concreteType": "JiraIssueSearchFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSets",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v19/*: any*/),
                      {
                        "concreteType": "JiraIssueSearchFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v20/*: any*/),
                          {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v24/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v28/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "shouldUseNewQuery",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v25/*: any*/),
                "kind": "LinkedField",
                "name": "jiraIssueSearchView",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": (v26/*: any*/),
                        "concreteType": "JiraIssueSearchFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          (v19/*: any*/),
                          {
                            "concreteType": "JiraIssueSearchFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v20/*: any*/),
                              {
                                "concreteType": "JiraIssueSearchFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v27/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "JiraSpreadsheetView",
                    "abstractKey": "__isJiraSpreadsheetView"
                  },
                  (v28/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "272634a6bad5f4495beb14443ac52d9b9a4e0be5253252159abbdb36fd238b15",
    "metadata": {},
    "name": "fetchColumnPickerOptionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2ce388ada0acb5edb4e205aa2242a1d0";

export default node;
